/**
 * 통계 테이블 합계 데이터 생성
 * @param statsData 통계 데이터
 * @param totalKeyList 합계 키 리스트
 * @returns 합계 데이터
 */
export const actionMakeTotalData = (statsData, totalKeyList) => {
    try {
        let isExistTotal = false;
        const totalCount = statsData.length;
        const result = statsData.reduce((acc, curr) => {
            totalKeyList.forEach((key, headerIndex) => {
                if (!key) {
                    acc[headerIndex] = '';
                    return;
                }
                if (!acc[headerIndex]) {
                    acc[headerIndex] = 0;
                }
                acc[headerIndex] = Number(acc[headerIndex]) + Number(curr[key.key]);
            });
            if (totalKeyList.length > 0) {
                isExistTotal = true;
            }
            return acc;
        }, []);
        // 평균 데이터 처리
        totalKeyList.forEach((v, index) => {
            if (v?.method === 'average') {
                result[index] = Number(result[index]) / totalCount;
            }
        });
        // 첫번째 셀이 빈 문자열인 경우 합계로 처리
        if (isExistTotal) {
            result[0] = '합계';
            return result;
        }
        return [];
    }
    catch (error) {
        console.error('makeTotalData error', error);
        return [];
    }
};
